import { NumberField } from '~/common/components';
import { usePurchaseContext } from '~/purchase/context';
import { Trans, useI18n, useLocale } from '~/common/context';
import { DEFAULT_EURO_SIGN } from '@wyz/utils';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';
import { useRedistributionServicePricingPolicyForm } from '~/purchase/components';
import { RedistributionServicePricingPolicyHelpers } from '~/purchase/helpers';
import { IRedistributionServicePricingForm } from '~/purchase/types';
// eslint-disable-next-line @wyz/module/no-relative-import
import './one-tyre-delivery-table.scss';

const OneTyreDeliveryTable: React.FC = () => {
  const pricingPolicyForm = useRedistributionServicePricingPolicyForm();
  const { t } = useI18n();
  const methods = useFormContext<IRedistributionServicePricingForm>();
  const tyreTypeColumns =
    RedistributionServicePricingPolicyHelpers.getTyreTypeColumns(
      t,
      pricingPolicyForm.vehicleTypeGroups.data?.data ?? [],
      true,
    );
  const { state } = usePurchaseContext();
  const locale = useLocale();
  const currencySymbol = state.targetCustomer?.deliveryInformation?.country
    .currencyIsoCode
    ? locale.formatters.currency(
        state.targetCustomer?.deliveryInformation?.country.currencyIsoCode,
      )
    : DEFAULT_EURO_SIGN;
  return (
    <div>
      <table className='redistribution-service-refinement-table'>
        <thead>
          <tr>
            <th style={{ width: '15%' }}>
              <Trans i18nKey='app.pricing_policy.redistribution_service.table.supplier_type_column' />
            </th>
            <th style={{ width: '10%' }}>
              <Trans i18nKey='app.common.unit_price_without_tax' />
            </th>
            {tyreTypeColumns.map((tyreType) => (
              <th key={tyreType.value}>{tyreType.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {pricingPolicyForm.supplierTypes.optionItems.map(
            (supplierTypeItem) => (
              <tr key={supplierTypeItem.value}>
                <td>{supplierTypeItem.label}</td>
                <td>
                  {pricingPolicyForm.mode === 'WRITE' && (
                    <NumberField
                      name={`defaultValue.${supplierTypeItem.value}.value`}
                      withKnobs={false}
                      size='sm'
                      placeholder='xx'
                      onChangeValue={(value) => {
                        tyreTypeColumns.map((vehicleTypeItem) => {
                          methods.setValue(
                            `oneTyreDelivery.supplierTypes.${supplierTypeItem.value}.tyreTypes.${vehicleTypeItem.value}.value`,
                            value,
                            {
                              shouldValidate: true,
                            },
                          );
                        });
                      }}
                    />
                  )}
                </td>
                {tyreTypeColumns.map((vehicleTypeItem) => (
                  <td
                    key={`${supplierTypeItem.value}.${vehicleTypeItem.value}`}
                  >
                    <NumberField
                      name={`oneTyreDelivery.supplierTypes.${supplierTypeItem.value}.tyreTypes.${vehicleTypeItem.value}.value`}
                      withKnobs={false}
                      size='sm'
                      placeholder='xx'
                      min={0}
                      feedbackType='tooltip'
                      onChangeValue={() =>
                        methods.resetField(
                          `defaultValue.${supplierTypeItem.value}.value`,
                          undefined,
                        )
                      }
                      sign={currencySymbol}
                    />
                  </td>
                ))}
              </tr>
            ),
          )}
        </tbody>
      </table>
    </div>
  );
};

export default OneTyreDeliveryTable;
